import React from "react";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../../assets/images/ssc-logo.png";
// import userIcon from "../../assets/images/user-icon.png";
import { FiChevronDown, FiLogOut, FiUser, FiX, FiMenu } from "react-icons/fi";
import Dropdown from "../Dropdown";
import { useKeycloak } from "../../utils/KeycloakProvider";
import { useFeature } from "../../hooks/useFeature";

interface HeaderProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
const Header: React.FC<HeaderProps> = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const bedfinder = useFeature("bedfinder");
  const safenight = useFeature("safenight");
  const { logout, profile } = useKeycloak();

  const backToHomeHandler = () => {
    if (bedfinder && !safenight) {
      navigate("/bedfinder", { replace: true });
    } else if (!bedfinder && safenight) {
      navigate("/safenight", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <header className="bg-white border md:border-none border-gray-200 box-shadow">
      <div className="container flex-center-between flex-nowrap mx-auto p-3 2xl:p-4">
        {/* Logo */}
        <div className="flex gap-x-3 items-center">
          <div className="flex justify-between items-center md:hidden p-2 cursor-pointer rounded border border-borderGray bg-white">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 focus:outline-none">
              {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
          <button onClick={backToHomeHandler}>
            <img src={Logo} className="h-8 2xl:h-10" alt="Logo" />
          </button>
        </div>

        {/* Menu */}
        <div className="md:w-auto" id="navbar-default">
          <ul className="font-medium flex flex-col items-cente md:flex-row md:space-x-5">
            {bedfinder && (
              <>
                <li className="hidden md:block">
                  <Link to="/bedfinder" className="text-primary 2xl:text-base font-semibold">
                    Locate a shelter bed
                  </Link>
                </li>
                <li className="text-gray-300 hidden md:block">|</li>
              </>
            )}
            {safenight && (
              <>
                <li className="hidden md:block">
                  <Link to="/safenight" className="text-secondary 2xl:text-base font-semibold">
                    Fund a hotel room
                  </Link>
                </li>
                <li className="text-gray-300 hidden md:block">|</li>
              </>
            )}
            {/* User Profile Dropdown */}
            <li className="flex gap-3 items-center">

              {/* Dropdown Component */}
              <Dropdown
                button={
                  <div className="flex items-center gap-2">
                    <span className="2xl:text-sm text-gray-700 font-semibold">{profile?.firstName + " " + profile?.lastName}</span>
                    <FiChevronDown className="text-gray-600 cursor-pointer" />
                  </div>
                }
              >
                {/* Dropdown Content */}
                <ul className="2xl:py-3 text-sm text-gray-700">
                  <li>
                    <Link
                      to={"/my-account"}
                      className="px-4 py-3 hover:bg-gray-100 text-xs 2xl:text-sm flex items-center gap-3"
                    >
                      <FiUser className="text-base 2xl:text-lg" /> <span>My Account</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="px-4 py-3 hover:bg-gray-100 text-xs 2xl:text-sm flex items-center gap-3"
                      onClick={() => logout()}
                    >
                      <FiLogOut className="text-base 2xl:text-lg" /> <span>Logout</span>
                    </Link>
                  </li>
                </ul>
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
